
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const Title = styled.span`
    text-align: center;
    font-size: 1rem;
    color: #fff;
    font-weight: 600;
    margin:0;
`;